import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { message } from "antd";

export const useFetchDashboardStatus = (start, end) => {
  return useQuery(
    ["getFetchDashboardStatus"],
    async (value) => {
      try {
        const endpoint = `/api/v1/dashboard/status/${start}/${end}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Dashboard Status..");
      }
    }
  );
};

export const useFetchChangeJob = () => {
  return useMutation(
    ["dashboardJobChange"],
    async (value) => {
      try {
        const endpoint = `/api/v1/dashboard/jobChanged`;
        const { result } = await POST(endpoint, value);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("ไม่สามารถอัปเดตหน้าที่ได้");
        throw error;
      }
    }
  );

}

export const useFetchSendCaseToEmployee = () => {
  return useMutation(
    ["getFetchSendCaseToEmployee"],
    async (value) => {
      try {
        const endpoint = `/api/v1/dashboard/sendCaseToEmployee`;
        const { result } = await POST(endpoint, value);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Send Case To Employee..", error);
      }
    }
  );
};

